import React from 'react';
import '../Style/Banner2.css'

const Banner2 = () => {
    return (
        <section className="banner-2">
            <div className="contnaier">
                <div className="content">
                    <span>hurry up and get 25% discount</span>
                    <h3>deals of the week</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos, nesciunt? Unde voluptas doloribus quia et.</p>
                    <a href="#banner" className="btn">Shop Now</a>
                </div>
            </div>
        </section>
    );
};

export default Banner2;
